import { namespace } from 'vuex-class';
import { ICreatePageState } from '@/dealroom/create-page/store/create-page.types';

export const CreatePage = namespace('dealroom/createPage');

export const state: ICreatePageState = {
  creating: false,
  createdPage: null,
  createdDocument: null,
  createdDocumentType: null,
};

export enum ECreatePageAction {
  Reset = 'reset',
  Create = 'create',
  CreateSuccess = 'createSuccess',
  CreateFailed = 'createFailed',
  EvaluateGoogleDriveError = 'evaluateGoogleDriveError',
}

export enum ECreatePageMutation {
  SetState = 'setState',
  SetCreating = 'setCreating',
  SetCreatedPage = 'setCreatedPage',
  SetCreatedDocument = 'setCreatedDocument',
  SetCreatedDocumentType = 'setCreatedDocumentType',
}
